import React from 'react';
import { useScript } from '../context/ScriptContext';

const MapSection: React.FC = () => {
  const { t } = useScript();

  return (
    <section className="map-section">
      <h2 className="map-heading">{t("Како до нас")}</h2>

      <div className="map-frame-container">
        <iframe
          title="Карта локације манастира Градац"
          aria-label="Карта локације манастира Градац"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8203.916466589275!2d20.53193794764461!3d43.366098133951674!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475634f5e9285a3b%3A0x890792859db56b85!2sMonastery%20Gradac!5e0!3m2!1sen!2srs!4v1765818881060!5m2!1sen!2srs"
          className="google-map"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  );
};

export default MapSection;
